/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppFlavourSearchModel } from '../../models/app-flavour-search-model';
import { AppFlavourSearchResultModel } from '../../models/app-flavour-search-result-model';

export interface AdminSearchPost$Params {
  
    /**
     * The search criteria.
     */
    body?: AppFlavourSearchModel
}

export function adminSearchPost(http: HttpClient, rootUrl: string, params?: AdminSearchPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<AppFlavourSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, adminSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<AppFlavourSearchResultModel>;
    })
  );
}

adminSearchPost.PATH = '/Admin/Search';
